import { render } from "./approvalDetail.vue?vue&type=template&id=6008681f&scoped=true"
import script from "./approvalDetail.vue?vue&type=script&lang=js"
export * from "./approvalDetail.vue?vue&type=script&lang=js"

import "./approvalDetail.vue?vue&type=style&index=0&id=6008681f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6008681f"]])

export default __exports__